export const PUBLIC_AUTH_PATHS = [
  "/",
  "/register",
  "/forgot-password",
  "/resetpassword",
  "/verify",
  "/verification-sent",
] as const;

/**
 * Check if the given pathname is a public authentication page
 */
export const isPublicAuthPage = (pathname: string): boolean => {
  return (
    PUBLIC_AUTH_PATHS.some(
      (path) =>
        pathname === path || (path !== "/" && pathname.startsWith(path)),
    ) ||
    pathname.startsWith("/reset-password") ||
    pathname.startsWith("/invite") ||
    pathname.startsWith("/verifyemail")
  );
};
